import React from 'react';
import { inject,observer } from 'mobx-react';
import { getEcCom,getLabel } from '../../../util/convert';
import Content from './Content';

@inject('locationMapStore')
@observer
export default class Main extends React.Component{
    render(){
        const { WeaDialog } = getEcCom();
        const { visible } = this.props;
        let dialogHeight = "624px";
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@n39dvd`}
                visible={visible}
                loadCss={true}
                initLoadCss={true}
                title={getLabel(502317, '查看轨迹')}
                icon="icon-coms-workflow"
                iconBgcolor='#0079DE'
                maskClosable={false}
                onCancel={this.doCancel}
                style={{width:"850px", height:dialogHeight}}
            >
                <Content ecId={`${this && this.props && this.props.ecId || ''}_Content@78s2k3`} {...this.props}/>
            </WeaDialog>
        )
    }
    doCancel = () => {
        const { locationMapStore } = this.props;
        locationMapStore.cancelEvent();
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/location-map/index.js